import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  spaces: [],
  spaceById: {},
  selectedSpace: '',
  month_events: {},
  day_events: {
    isFetching: false,
    events: []
  },
  selectedDate: new Date(),
  isFetching: false,
  loadCalendar: false,
  loadCalendarAndDayEvents: false,
  operating_hours: [],
  lastUpdated: '',
  error: ''
};

export default function calendar (state = initialState, action) {
  const {
    spacesArray,
    selectedSpace,
    selectedDate,
    month_events,
    day_events,
    error,
    loadCalendar,
    loadCalendarAndDayEvents,
    operating_hours,
    lastUpdated
  } = action;
  // customizer resets objects/ array from non-empty to empty
  const mergeCustomizer = (objectValue, sourceValue) => {
    if (!_.isNull(sourceValue) || !_.isUndefined(sourceValue)) {
      return sourceValue;
    }
    return objectValue;
  };

  switch (action.type) {
  case types.CALENDAR_SPACES_FETCH_SUCCESS:
    return _.merge({}, state, {
      spaces: spacesArray,
      spaceById: _.keyBy(spacesArray, '_id'),
      error
    });

  case types.CALENDAR_SPACES_FETCH_FAILURE:
    return _.merge({}, state, {
      error
    });

  case types.SPACES_SELECT:
    return _.merge({}, state, {
      selectedSpace,
      loadCalendarAndDayEvents
    });

  case types.CALENDAR_FETCH_FAILURE:
    return _.merge({}, state, {
      error,
      loadCalendar,
      loadCalendarAndDayEvents
    });

  case types.CALENDAR_FETCH_SUCCESS:
    return _.mergeWith({}, state, {
      month_events,
      lastUpdated,
      error,
      loadCalendar,
      loadCalendarAndDayEvents
    }, mergeCustomizer);

  case types.OPHOURS_FETCH_FAILURE:
    return _.merge({}, state, {
      error,
      operating_hours
    });

  case types.OPHOURS_FETCH_SUCCESS:
    return _.mergeWith({}, state, {
      error,
      operating_hours
    }, mergeCustomizer);

  case types.DATE_SELECT:
    return selectedDate && _.merge({}, state, {
      selectedDate
    });

  case types.DAY_EVENTS_FETCH_REQUEST:
    return _.merge({}, state, {
      day_events
    });

  case types.DAY_EVENTS_FETCH_SUCCESS:
    return _.mergeWith({}, state, {
      day_events,
      error,
      loadCalendarAndDayEvents
    }, mergeCustomizer);

  case types.DAY_EVENTS_FETCH_FAILURE:
    return _.merge({}, state, {
      error,
      day_events,
      loadCalendarAndDayEvents
    });

  case types.POST_BLOCK_DAY_SUCCESS:
    return _.mergeWith({}, state, {
      day_events,
      error,
      loadCalendarAndDayEvents
    }, mergeCustomizer);

  case types.POST_BLOCK_DAY_FAILURE:
    return _.merge({}, state, {
      error,
      loadCalendarAndDayEvents
    });

  case types.DELETE_BLOCK_DAY_SUCCESS:
    return _.mergeWith({}, state, {
      day_events,
      error,
      loadCalendar
    }, mergeCustomizer);

  case types.DELETE_BLOCK_DAY_FAILURE:
    return _.merge({}, state, {
      error,
      loadCalendar
    });

  case types.RESET_DAY_EVENTS:
    return _.mergeWith({}, state, {
      day_events: {
        isFetching: false,
        events: []
      }
    }, mergeCustomizer);

  default:
    return state;
  }
}
